// ============================================================
// Permission & Field Helpers - chuẩn hóa so sánh
// Tránh bug do backend trả string vs number không thống nhất
// ============================================================

export const PERMISSION = {
  ADMIN: 1,
  MODERATOR: 2,
  MANAGER: 3,
  SALE: 4,
};

export const PERMISSION_LABELS = {
  1: 'Quản Trị',
  2: 'Kiểm Duyệt Viên',
  3: 'Quản Lý',
  4: 'Sale',
};

const toNumber = (val) => {
  if (val === null || val === undefined || val === '') return null;
  const n = Number(val);
  return Number.isFinite(n) ? n : null;
};

const toString = (val) => {
  if (val === null || val === undefined) return '';
  return String(val);
};

export const getPermission = (auth) => toNumber(auth?.permission);

export const isAdmin = (auth) => getPermission(auth) === PERMISSION.ADMIN;
export const isModerator = (auth) => getPermission(auth) === PERMISSION.MODERATOR;
export const isManager = (auth) => getPermission(auth) === PERMISSION.MANAGER;
export const isSale = (auth) => getPermission(auth) === PERMISSION.SALE;

export const isAdminOrModerator = (auth) => isAdmin(auth) || isModerator(auth);
export const isStaff = (auth) => getPermission(auth) !== null;

export const permissionLabel = (auth) => PERMISSION_LABELS[getPermission(auth)] || '';

export const hasAnyPermission = (auth, allowedList) => {
  const p = getPermission(auth);
  if (p === null) return false;
  if (!Array.isArray(allowedList) || allowedList.length === 0) return true;
  return allowedList.map(Number).includes(p);
};

// ============================================================
// Field comparison helpers - chuẩn hóa so sánh field từ DB
// ============================================================

export const eqNum = (val, target) => toNumber(val) === toNumber(target);
export const neNum = (val, target) => toNumber(val) !== toNumber(target);

export const eqStr = (val, target) => toString(val) === toString(target);
export const neStr = (val, target) => toString(val) !== toString(target);

export const isBdsStatus = (val, target) => toString(val) === toString(target);
export const isOldData = (val) => toNumber(val) === 2;
export const isDocQuyen = (val) => toNumber(val) === 1;
export const isHangHot = (val) => toNumber(val) === 2;
export const isHanche = (val, target) => toNumber(val) === toNumber(target);

// So sánh giá an toàn (chấp nhận cả string lẫn number)
export const giaPos = (val) => toNumber(val) > 0;
export const sdtPos = (val) => toNumber(val) > 0;

// ============================================================
// Logic phức tạp hay sai - tách thành hàm có tên rõ ràng
// ============================================================

// Check hiển thị nút "Xem SĐT" theo rule kinh doanh
// ishanche: 0=bình thường, 1=hạn chế, 2=cấm
// isdocquyen: 0=bthường, 1=độc quyền, 2=hot
// isAdmin: bypass mọi check
export const canViewPhone = (auth, data, giaCmt) => {
  if (isAdmin(auth) || auth?.username === 'Duong01') return true;
  const ishanche = toNumber(data?.ishanche);
  const isdocquyen = toNumber(data?.isdocquyen);
  const gia = toNumber(data?.gia);
  const giaC = toNumber(giaCmt);
  const limit = toNumber(auth?.s3);

  if (ishanche === 2 || isdocquyen === 1 || ishanche === 1) return false;
  if (ishanche !== 0) return false;
  if (isdocquyen !== 0 && isdocquyen !== 2) return false;
  const effectiveGia = giaC > 0 ? giaC : gia;
  if (limit === null || effectiveGia === null) return false;
  return effectiveGia <= limit;
};
